export const TURN_MODE_MAP = {
  'coordinateTurn': 'coordinateTurn',
  'Point and stop con': 'toPointAndStopWithContinuityCurvature',
  'Point and stop discon': 'toPointAndStopWithDiscontinuityCurvature',
  'Point and pass con': 'toPointAndPassWithContinuityCurvature',
} as const

export type FrontendTurnType = keyof typeof TURN_MODE_MAP
export type BackendTurnMode = (typeof TURN_MODE_MAP)[FrontendTurnType]

export const toBackendTurnMode = (frontend: string): BackendTurnMode =>
  TURN_MODE_MAP[frontend as FrontendTurnType] ?? 'toPointAndPassWithContinuityCurvature'

export const toFrontendTurnMode = (backend: string): FrontendTurnType =>
  (Object.entries(TURN_MODE_MAP).find(([, v]) => v === backend)?.[0] ?? 'Point and pass con') as FrontendTurnType

export const DEFAULT_DAMPING_DIST = 2
export const AREA_MISSION_DAMPING_DIST = 2
export const DEFAULT_GIMBAL_PITCH = -90
export const DEFAULT_WAYPOINT_RADIUS = 5
export const MIN_PHOTO_INTERVAL = 0.1
export const DEFAULT_DISTANCE_INTERVAL = 5
export const DEFAULT_TIME_INTERVAL = 2

export const EMPTY_AREA_MISSION_STATS = {
  area: 0, totalDistance: 0, estimatedTime: 0, totalPhotos: 0,
  gsd: 0, numLines: 0, lineSpacing: 0, photoSpacing: 0,
  footprintWidth: 0, footprintHeight: 0, obliqueGsd: 0,
  irGsd: 0, terrainAltitude: 0,
} as const
